import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import type { ComponentProps } from 'react';

export const CoreLoader = (props: ComponentProps<typeof Spin>) => (
	<div>
		<Spin
			{...{
				indicator: (
					<LoadingOutlined
						{...{
							spin: true,
						}}
					/>
				),
				...props,
			}}
		/>
	</div>
);
